import React from 'react';
import * as PropTypes from 'prop-types';
import { Accordion } from '@reach/accordion';

import Loading from '$landing-page/components/loading';

import AccordionItem from './accordion-item';
import useStyles from './styles';

const PublicationsAccordionList = (props) => {
    const { items, loading, error } = props;

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Loading loading={loading} error={error} />
            {!loading && !error && items.length === 0 ? (
                <p className={classes.noItemFound}>No publication found!</p>
            ) : (
                <Accordion collapsible>
                    {items.map((publication) => (
                        <AccordionItem key={publication.id} item={publication} />
                    ))}
                </Accordion>
            )}
        </div>
    );
};

PublicationsAccordionList.defaultProps = {
    loading: false,
    error: false,
};

PublicationsAccordionList.propTypes = {
    items: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.bool,
};

export default PublicationsAccordionList;
